import { Show } from "@refinedev/antd";
import { Tag, Space } from "antd";
import { IResourceComponentsProps, useShow } from "@refinedev/core";
import { DollarOutlined } from "@ant-design/icons";

import { ICurrency } from "interfaces";
import {
  ShowField,
  ShowSection,
  ShowFieldGrid,
} from "components/show";

export const CurrencyShow: React.FC<IResourceComponentsProps> = () => {
  const { result, query: { isLoading } } = useShow<ICurrency>();
  const record = result;

  return (
    <Show
      breadcrumb={false}
      headerProps={{
        onBack: () => window.history.back(),
        subTitle: "active currency",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
      }}
      isLoading={isLoading}
    >
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <ShowSection
          title="Currency Information"
          subtitle="Monetary unit details"
          icon={<DollarOutlined />}
          variant="elevated"
        >
          <ShowFieldGrid columns={3}>
            <ShowField label="Currency Name" value={record?.name} />
            <ShowField label="Currency Code" value={record?.code} type="code" copyable />
            <ShowField label="Currency Symbol" value={record?.symbol} />
          </ShowFieldGrid>
        </ShowSection>
      </Space>
    </Show>
  );
};
